import React from 'react';
import { Radio, RadioGroupProps as AntdRadioGroupProps } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio/interface';
import classnames from 'classnames';
import cn from './styles.module.scss';

export enum RadioGroupType {
  TabsPrimary = 'tabsPrimary',
  TabsSecondary = 'tabsSecondary',
  Buttons = 'buttons',
}

export type RadioGroupOption = {
  value: string | number,
  label: string,
  disabled?: boolean,
};

export type RadioGroupProps = Omit<AntdRadioGroupProps, 'options' | 'defaultValue' | 'value' | 'onChange' | 'type'> & {
  options: RadioGroupOption[],
  defaultValue?: string | number,
  value?: string | number,
  containerClassName?: string,
  buttonClassName?: string,
  testId?: string,
  onChange?: (event: RadioChangeEvent, value: any) => void,
  type?: RadioGroupType
};

export const RadioGroup = ({
  defaultValue,
  options,
  size,
  onChange,
  type = RadioGroupType.TabsPrimary,
  containerClassName,
  buttonClassName,
  testId,
  ...props
}: RadioGroupProps) => {
  const handleChange = (event: RadioChangeEvent) => {
    const { target: { value } } = event;
    if (onChange) {
      onChange(event, value);
    }
  };

  return (
    <div data-testid={testId} className={classnames(cn.container, cn[type], containerClassName)}>
      <Radio.Group size={size} defaultValue={defaultValue} {...props}>
        {options.map((item) => (
          <Radio.Button
            key={item.value}
            value={item.value}
            onChange={handleChange}
            className={buttonClassName}
            disabled={item.disabled}
          >
            {item.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
};
